export { default as updateSellerGdm } from './updateSellerGdm';

export type {
  SellerGdmUpdateOnSubmitFunction,
  SellerGdmUpdateOnSubmitPayload,
} from './updateSellerGdm.type';
